import { render, staticRenderFns } from "./stock_charts.vue?vue&type=template&id=52f03ccb&scoped=true&"
import script from "./stock_charts.vue?vue&type=script&lang=js&"
export * from "./stock_charts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f03ccb",
  null
  
)

export default component.exports